export default __webpack_public_path__ + "static/media/surveyVectorHsb.b0df208a.svg";